import React from 'react';

import { withUAPLThemedStyles } from '../../with-themed-styles';
import { AdPlacementMmaBase } from '../mma-ad-placement-base';

import {
  getImgExtWideImage191x100Styles,
  getImgExtMSEdgeSingleCarousel178x100Styles,
  getImgExtBingDesktopSingleImage178x100Styles,
  getImgExtMSEdgeMediumHeadline172x100Styles,
  getImgExtMSNSingleCarousel169x100Styles,
  getImgExtMSNMediumHeadline155x100Styles,
  getImgExtMSNInArticle150x100Styles,
  getImgExtMSNSmallHeadline133x100Styles,
  getImgExtSquareImage1x1Styles,
  getImgExtMSNDoubleCarousel93x100Styles,
} from '../../styles';

export const AdPlacementImgExtWideImage191x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBase>) => (<AdPlacementMmaBase
    {...props}
    showShortHeadline
    showLongHeadline={false}
    showFinalUrl={false}
    showDescription
    showCallToAction={false}
    showAdLabel={false}
    showGradient={false}
    isMultiLineShortHeadline
    isMultiLineDescription
    callToAction={undefined}
    showBusinessName
    showBusinessNameAdLabel
  />),
  getImgExtWideImage191x100Styles,
  { componentName: 'AdPlacementImgExtWideImage191x100' }
);

export const AdPlacementImgExtMSEdgeSingleCarousel178x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBase>) => (<AdPlacementMmaBase
    {...props}
    showShortHeadline
    showLongHeadline={false}
    showFinalUrl={false}
    showDescription
    showCallToAction={false}
    showAdLabel={false}
    showGradient
    isMultiLineShortHeadline
    description={undefined}
    callToAction={undefined}
    showBusinessName
    showBusinessNameAdLabel
  />),
  getImgExtMSEdgeSingleCarousel178x100Styles,
  { componentName: 'AdPlacementImgExtMSEdgeSingleCarousel178x100' }
);

export const AdPlacementImgExtBingDesktopSingleImage178x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBase>) => (<AdPlacementMmaBase
    {...props}
    showShortHeadline={false}
    isMultiLineShortHeadline={false}
    showLongHeadline
    isMultiLineLongHeadline
    showFinalUrl
    isMultiLineFinalUrl
    showDescription
    isMultiLineDescription
    showCallToAction={false}
    showAdLabel={false}
    showGradient={false}
    showBusinessName={false}
    showBusinessNameAdLabel={false}
  />),
  getImgExtBingDesktopSingleImage178x100Styles,
  { componentName: 'AdPlacementImgExtBingDesktopSingleImage178x100' }
);

export const AdPlacementImgExtMSEdgeMediumHeadline172x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBase>) => (<AdPlacementMmaBase
    {...props}
    showShortHeadline={false}
    isMultiLineShortHeadline={false}
    showLongHeadline
    isMultiLineLongHeadline
    showFinalUrl={false}
    isMultiLineFinalUrl={false}
    showDescription={false}
    isMultiLineDescription={false}
    showCallToAction={false}
    showAdLabel={false}
    showGradient
    showBusinessName
    showBusinessNameAdLabel
  />),
  getImgExtMSEdgeMediumHeadline172x100Styles,
  { componentName: 'AdPlacementImgExtMSEdgeMediumHeadline172x100' }
);

export const AdPlacementImgExtMSNSingleCarousel169x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBase>) => (<AdPlacementMmaBase
    {...props}
    showShortHeadline={false}
    isMultiLineShortHeadline={false}
    showLongHeadline
    isMultiLineLongHeadline
    showFinalUrl={false}
    isMultiLineFinalUrl={false}
    showDescription={false}
    isMultiLineDescription={false}
    showCallToAction={false}
    showAdLabel={false}
    showGradient
    showBusinessName
    showBusinessNameAdLabel
  />),
  getImgExtMSNSingleCarousel169x100Styles,
  { componentName: 'AdPlacementImgExtMSNSingleCarousel169x100' }
);

export const AdPlacementImgExtMSNMediumHeadline155x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBase>) => (<AdPlacementMmaBase
    {...props}
    showShortHeadline={false}
    isMultiLineShortHeadline={false}
    showLongHeadline
    isMultiLineLongHeadline
    showFinalUrl={false}
    isMultiLineFinalUrl={false}
    showDescription={false}
    isMultiLineDescription={false}
    showCallToAction={false}
    showAdLabel={false}
    showGradient
    showBusinessName
    showBusinessNameAdLabel
  />),
  getImgExtMSNMediumHeadline155x100Styles,
  { componentName: 'AdPlacementImgExtMSNMediumHeadline155x100' }
);

export const AdPlacementImgExtMSNInArticle150x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBase>) => (<AdPlacementMmaBase
    {...props}
    showShortHeadline
    isMultiLineShortHeadline
    showLongHeadline={false}
    isMultiLineLongHeadline={false}
    showFinalUrl={false}
    isMultiLineFinalUrl={false}
    showDescription
    isMultiLineDescription
    showCallToAction={false}
    showAdLabel={false}
    showGradient
    showBusinessName
    showBusinessNameAdLabel
  />),
  getImgExtMSNInArticle150x100Styles,
  { componentName: 'AdPlacementImgExtMSNInArticle150x100' }
);

export const AdPlacementImgExtMSNSmallHeadline133x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBase>) => (<AdPlacementMmaBase
    {...props}
    showShortHeadline
    isMultiLineShortHeadline
    showLongHeadline={false}
    showFinalUrl={false}
    showDescription={false}
    showCallToAction={false}
    showAdLabel={false}
    showGradient={false}
    showBusinessName
    showBusinessNameAdLabel
  />),
  getImgExtMSNSmallHeadline133x100Styles,
  { componentName: 'AdPlacementImgExtMSNSmallHeadline133x100' }
);

export const AdPlacementImgExtSquareImage1x1 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBase>) => (<AdPlacementMmaBase
    {...props}
    showShortHeadline
    isMultiLineShortHeadline
    showLongHeadline={false}
    showFinalUrl={false}
    showDescription={false}
    showCallToAction={false}
    showAdLabel={false}
    showGradient
    showBusinessName
    showBusinessNameAdLabel
  />),
  getImgExtSquareImage1x1Styles,
  { componentName: 'AdPlacementImgExtSquareImage1x1' }
);

export const AdPlacementImgExtMSNDoubleCarousel93x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBase>) => (<AdPlacementMmaBase
    {...props}
    showShortHeadline
    isMultiLineShortHeadline
    showLongHeadline={false}
    showFinalUrl={false}
    showDescription={false}
    showCallToAction={false}
    showAdLabel={false}
    showGradient
    showBusinessName
    showBusinessNameAdLabel
  />),
  getImgExtMSNDoubleCarousel93x100Styles,
  { componentName: 'AdPlacementImgExtMSNDoubleCarousel93x100' }
);
